<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="apply-view" v-if="!result">
                        <p>您是否要接受{{ playername }}的老友回归邀请，</p>
                        <p>想要与他并肩作战？</p>

                        <p class="warn"><em class="icon i-warn"></em>活动期间，同时只能接受一个邀请</p>

                        <div class="ctrl">
                            <div class="u-btn ok" @click="invite_apply"></div>
                            <div class="u-btn cancel" @click="reject_apply"></div>
                        </div>
                    </div>

                    <div class="success-view result-view" v-if="result && success">
                        <div class="title t-success"></div>
                        <p>你已经接受<b>{{ playername }}</b>的回归邀请，</p>
                        <p>现在登录游戏，即可领取限时回归礼包！</p>

                        <div class="u-btn ok" @click="destroyElement"></div>
                    </div>

                    <div class="error-view result-view" v-if="result && !success">
                        <div class="title t-error"></div>
                        <p>{{ info }}</p>

                        <div class="u-btn ok" @click="destroyElement"></div>
                    </div>

                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'apply_modal',
    data : function () {
        return {
            visible : false,
            is_return : false,
            playername : '友善的仙术师X',
            result : false,
            success : true,
            info : '',
            login : 0,
            aid : 0,       
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        reject_apply (){
            localStorage.setItem('_code', '');
            window.history.pushState({}, 0, this.$global.domain);
            this.$go_back_page();
            this.destroyElement ();
        },
        invite_apply (){
            let _this = this;

            if(!_this.$login_status())return _this.$mslogin.open();
            if(~~_this.$bind_status() < 1){
                _this.destroyElement();
                return _this.$bind();
            }

            _this.$axios.post(_this.$global.ajax_url_map.invite_apply,{
                areaId : _this.aid,
                inviteCode : _this.code,
            })
            .then(response => {
                _this.result = true;
                if(response.data.code == 0){
                    //_this.destroyElement();
                    _this.$toast('成功');               
                    localStorage.setItem('_code', '');
                    window.history.pushState({}, 0, _this.$global.domain);
                    _this.$go_back_page();
                }
                else{
                    localStorage.setItem('_code', '');
                    window.history.pushState({}, 0, _this.$global.domain);
                    _this.success = false;
                    _this.info = response.data.message;
                    _this.$go_back_page();
                }
            });
        },
    }    
}
</script>

<style scoped>

@media screen and (min-device-width: 1025px){
    .apply-modal{
        width: 469px;
        height: 275px;
        background-image: url(../../images/bg-modal-apply.png);
    }

    .apply-modal .dialog-wrapper{
        padding: 40px 30px 0;
    }

    .apply-view p{
        line-height: 1.8;
        text-align: center;
        color: #63544b;
    }

    .apply-view .warn{
        margin-top: 20px;
        margin-bottom: 15px;
        line-height: 1.6;
        color: #9f392f;
        text-align: center;
    }

    .i-warn{
        display: inline-block;
        vertical-align: text-bottom;
        width: 17px;
        height: 17px;
        margin-right: 15px;
        background-image: url(../../images/icon-warn.png);
    }
    
    .apply-view .ctrl{
        display: flex;
        justify-content: space-between;
        margin: 40px 30px 0;
    }

    .apply-view .u-btn.ok{
        width: 166px;
        height: 49px;
        background-image: url(../../images/btn-accept.png);    
    }
    
    .apply-view .u-btn.ok:hover{
        background-image: url(../../images/btn-accept_hover.png);   
    }
    
    .apply-view .u-btn.cancel{
        width: 166px;
        height: 49px;
        background-image: url(../../images/btn-re.png);    
    }
    
    .apply-view .u-btn.cancel:hover{
        background-image: url(../../images/btn-re_hover.png);   
    }
    
    /* success */
    .t-success{
        width: 207px;
        height: 29px;
        margin: 0 auto 40px;
        background-image: url(../../images/title-success.png);        
    }

    .result-view p{
        line-height: 2;
        text-align: center;
        color: #63544b;
    }

    .result-view p b{
        color: #497e89;
    }

    .result-view .u-btn.ok{
        position: absolute;
        bottom: 30px;
        left: 50%;
        width: 166px;
        height: 49px;
        margin: 25px auto 0;
        background-image: url(../../images/btn-iknow.png);   
        transform: translateX(-50%);   
    }    

    .result-view .u-btn.ok:hover{
        background-image: url(../../images/btn-iknow_hover.png);   
    } 
    
    .t-error{
        width: 217px;
        height: 29px;
        margin: 0 auto 40px;
        background-image: url(../../images/title-error.png);        
    } 
}
    
@media screen and (max-device-width: 1024px){
    .apply-modal{
        width: 609px;
        height: 411px;
        background-image: url(../../images/m/bg-modal-apply.png);
    }

    .apply-modal .dialog-wrapper{
        padding: 70px 30px 0;
    }

    .apply-view p{
        line-height: 1.8;
        text-align: center;
        color: #63544b;
    }

    .apply-view .warn{
        margin-top: 40px;
        margin-bottom: 15px;
        line-height: 1.6;
        color: #9f392f;
        text-align: center;
    }

    .i-warn{
        display: inline-block;
        vertical-align: text-bottom;
        width: 23px;
        height: 23px;
        margin-right: 15px;
        background-image: url(../../images/m/icon-warn.png);
    }
    
    .apply-view .ctrl{
        position: absolute;
        left: 0;
        bottom: 40px;
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
    }

    .apply-view .u-btn.ok{
        width: 218px;
        height: 65px;
        background-image: url(../../images/m/btn-accept.png);    
    }
   
    .apply-view .u-btn.cancel{
        width: 218px;
        height: 65px;
        background-image: url(../../images/m/btn-re.png);    
    }
    
    /* success */
    .t-success{
        width: 240px;
        height: 35px;
        margin: 0 auto 50px;
        background-image: url(../../images/m/title-success.png);        
    }

    .result-view p{
        line-height: 2;
        text-align: center;
        color: #63544b;
    }

    .result-view p b{
        color: #497e89;
    }

    .result-view .u-btn.ok{
        position: absolute;
        bottom: 60px;
        left: 50%;
        width: 218px;
        height: 65px;
        margin: 25px auto 0;
        background-image: url(../../images/m/btn-iknow.png);
        transform: translateX(-50%);   
    }
   
    .t-error{
        width: 247px;
        height: 35px;
        margin: 0 auto 50px;
        background-image: url(../../images/m/title-err.png);        
    } 
} 

   

</style>


// WEBPACK FOOTER //
// src/components/ApplyModal/applyModal.vue